import { ERegions } from '../../../../shared/constants';

export const includedLocationIds = [ERegions.moscow, ERegions.moscowRegion];

export default [
  'categoryService',
  'addFormService',
  'geoService',
  'userService',
  'apiService',
  (categoryService, addFormService, geoService, userService, apiService) => {
    // Соответствие объявления ограничениям проекта
    const isCanAdvertiseObject = () => {
      const ad = addFormService.ad;
      const categoryInfo = categoryService.getInfoByCategory(ad.category);

      const isInMoscowOrMO = includedLocationIds.includes(geoService.getLocationId());

      return (
        categoryInfo.dealType === 'sale' && categoryInfo.objectType === 'flat' && ad.isByHomeowner && isInMoscowOrMO
      );
    };

    // Проверяем, что пользователь не пользовался раньше услугой
    const isUserInABGroup = () => {
      return ['call', 'advertise'].includes(userService.user.freeProfessionalHelpBlockVariant);
    };

    const getABGroup = () => {
      if (userService.user.freeProfessionalHelpBlockVariant === 'call') {
        return 'A';
      }
      if (userService.user.freeProfessionalHelpBlockVariant === 'advertise') {
        return 'B';
      }

      return '';
    };

    const service = {};

    // Позволяет послать запрос, если id известен в контексте вызова
    service.sendAdvertiseRequest = offerId => {
      apiService.sendAdvertiseRequest({ offerId });
    };
    // Позволяет послать запрос после публикации объявления из любого контроллера
    service.sendAdvertiseRequestFromModal = () => {
      return apiService.sendAdvertiseRequest({ offerId: service.offerId });
    };
    service.isCanAdvertiseObject = () => isCanAdvertiseObject();
    service.isUserInABGroup = () => isUserInABGroup();
    service.isBannerVisible = () => {
      return isCanAdvertiseObject() && isUserInABGroup();
    };
    service.getABGroup = () => getABGroup();
    service.isRequestSend = false;

    return service;
  },
];
